import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { AuthService } from './auth.service';

/**
 * Telas reservadas ao dono da conta (Multiusuários v1.0, CU-17tm466h1cm):
 * token da API de Parceiros e o que mais a API recusa com `owner_only`.
 *
 * Só usabilidade — quem barra de verdade é o backend (`account.owner`).
 */
@Injectable({ providedIn: 'root' })
export class AccountOwnerGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(): boolean | UrlTree {
    return this.authService.isAccountOwner
      ? true
      : this.router.parseUrl('/dashboard');
  }
}
